var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBadgeBg = function SvgBadgeBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 177,
    viewBox: "0 0 131 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.9548,
    y: 6.69629,
    width: 75.8795,
    height: 104.615,
    rx: 37.9397,
    transform: "rotate(6.33459 44.9548 6.69629)",
    fill: "#8DCAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2432 50.9883C70.9857 46.3697 71.2508 43.6321 72.5168 38.4613",
    stroke: "black",
    strokeWidth: 3.83222,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5068 52C79.2493 47.3814 79.5145 44.6438 80.7805 39.473",
    stroke: "black",
    strokeWidth: 3.83222,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2595 60.7559C59.431 56.8473 64.6946 55.2795 67.8737 57.5599C72.6213 60.9655 77.1003 60.8273 82.1839 57.8934C86.0071 55.6869 91.3842 58.059 91.1907 62.469C91.0142 66.4908 88.8268 70.2675 85.1174 71.8315C77.9936 74.835 72.3195 74.7317 64.8194 70.9567C61.0635 69.0662 59.0751 64.9567 59.2595 60.7559Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.527 67.954C88.4913 69.6532 86.9899 71.0361 85.0887 71.8376C81.4181 73.3852 78.1324 74.108 74.7835 73.9287C76.0164 71.3703 79.4927 69.0614 83.8956 68.1787C85.8865 67.7795 87.8151 67.7224 89.527 67.954Z",
    fill: "#F48FB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.056 61.0897L118.388 49.0923C120.805 27.3211 105.115 7.7129 83.344 5.29604V5.29604C61.5728 2.87917 41.9646 18.5689 39.5477 40.3401L38.2159 52.3375",
    stroke: "black",
    strokeWidth: 2.87408
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1573 40.3468C31.3324 38.7691 32.7533 37.6322 34.3309 37.8073L41.1866 38.5684L38.7167 60.8175C38.6096 61.7817 37.7413 62.4765 36.7771 62.3695L31.6672 61.8022C30.0896 61.6271 28.9526 60.2062 29.1278 58.6286L31.1573 40.3468Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.476 69.2138C124.301 70.7914 122.88 71.9283 121.303 71.7532L116.263 71.1937C115.26 71.0824 114.537 70.1793 114.649 69.1766L117.111 46.9973L123.966 47.7583C125.544 47.9335 126.681 49.3544 126.506 50.932L124.476 69.2138Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8342 55.7744C46.393 61.7319 47.6571 63.2366 56.9101 63.6755M52.8473 61.2003L57.1321 61.676L56.6564 65.9608L52.689 65.2312L52.8473 61.2003Z",
    stroke: "black",
    strokeWidth: 1.72445
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4518 85.7854C65.1288 85.7322 67.4046 83.8127 67.9121 81.1837C68.6122 77.5565 65.7129 74.2432 62.0212 74.3789C41.3701 75.1381 28.5414 73.6869 14.2702 66.7175C10.8279 65.0365 6.59868 66.9371 5.87267 70.6985C5.41925 73.0476 6.52125 75.4392 8.64917 76.5328C27.1156 86.0227 40.8255 86.2154 62.4518 85.7854Z",
    fill: "#8DCAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4023 91.8768C81.6883 90.4829 82.6881 87.6785 81.8027 85.1517C80.5812 81.6653 76.4079 80.2626 73.2867 82.2387C55.8269 93.293 44.0124 98.4989 28.1732 99.6635C24.3527 99.9444 21.6557 103.716 22.9224 107.331C23.7135 109.589 25.8699 111.101 28.259 110.974C48.9921 109.875 60.9341 103.138 79.4023 91.8768Z",
    fill: "#549FE0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2466 104.956H56.6426C51.8448 130.871 51.7323 145.082 56.6426 169.788H67.2466C61.8841 148.386 61.8463 134.224 67.2466 104.956Z",
    fill: "#8DCAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5896 174.724C68.5896 169.403 64.2763 165.09 58.9555 165.09H55.0997C51.5043 165.09 48.5896 168.004 48.5896 171.6V174.217C48.5896 175.663 49.7615 176.835 51.2071 176.835H66.4788C67.6445 176.835 68.5896 175.89 68.5896 174.724Z",
    fill: "#8DCAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2466 104.956H81.6426C76.8448 130.871 76.7323 145.082 81.6426 169.788H92.2466C86.8841 148.386 86.8463 134.224 92.2466 104.956Z",
    fill: "#8DCAFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5896 174.724C93.5896 169.403 89.2763 165.09 83.9555 165.09H80.0997C76.5043 165.09 73.5896 168.004 73.5896 171.6V174.217C73.5896 175.663 74.7615 176.835 76.2071 176.835H91.4788C92.6445 176.835 93.5896 175.89 93.5896 174.724Z",
    fill: "#8DCAFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "badge-bg.49bd98dcc8269cf5a57b324879528660.svg";